import { IAccessLevel } from '@quesmed/types/models';
import { lazy, Suspense } from 'react';
import { useAuth } from '@/store';

const Dashboard = () => {
  const accessLevel = useAuth().accessLevel;

  const mapping: Record<IAccessLevel, React.LazyExoticComponent<React.ComponentType> | null> = {
    [IAccessLevel.SUPER_ADMIN]: lazy(() =>
      import('../../components/dashboards/super-admin-board.js').then((module) => ({
        default: module.SuperAdminBoard,
      })),
    ),
    [IAccessLevel.ADMINISTRATOR]: lazy(() =>
      import('../../components/dashboards/admin-board.js').then((module) => ({ default: module.AdminBoard })),
    ),

    [IAccessLevel.MARKETING]: lazy(() =>
      import('../../components/dashboards/sales-board.js').then((module) => ({ default: module.SalesBoard })),
    ),
    [IAccessLevel.WRITER]: lazy(() =>
      import('../../components/dashboards/writer-board.js').then((module) => ({
        default: module.WriterBoard,
      })),
    ),
    [IAccessLevel.EDITOR]: lazy(() =>
      import('../../components/dashboards/editor-board.js').then((module) => ({
        default: module.EditorBoard,
      })),
    ),
    [IAccessLevel.SENIOR_EDITOR]: lazy(() =>
      import('../../components/dashboards/editor-board.js').then((module) => ({
        default: module.EditorBoard,
      })),
    ),
    [IAccessLevel.SUBSCRIBER]: null,
    [IAccessLevel.TUTOR]: null,
    [IAccessLevel.DEMO]: null,
    [IAccessLevel.EXPIRED]: null,
    // university admins can't log in here (loginAdmin rejects them); they use the university panel
    [IAccessLevel.UNIVERSITY_ADMIN]: null,
  };

  const LazyComponent = accessLevel ? mapping[accessLevel] : null;

  return LazyComponent ? (
    <Suspense fallback={<div>Loading dashboard...</div>}>
      <LazyComponent />
    </Suspense>
  ) : null;
};

export default Dashboard;
